const mainCollectionElement = document.querySelector(".collection__main-area");
const filters = document.querySelector(".filter-sidebar__filters [data-filter-bar-filters-inner]");
const activeFilters = document.querySelector(".filter-sidebar__active-filters");
const trigger = document.querySelector(".filter-bar__button.filter-bar__button--filters");
const filterContainer = document.querySelector(".filter-sidebar__filters .filter-bar__filters-inner");
const triggerText = trigger.querySelector(".filter-sidebar__trigger-text");

const expandButtons = document.querySelectorAll("[data-show-filters]");
const contractButtons = document.querySelectorAll("[data-hide-filters]");

expandButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    e.preventDefault();
    let container = e.target.closest("[data-filter-group-values]");
    if (!container) container = e.target.closest(".filter-drawer__group");
    const list = container.querySelector("[data-filter-count]");
    list.style.maxHeight = list.scrollHeight + "px";
    e.target.style.display = "none";
    container.querySelector("[data-hide-filters]").style.removeProperty("display");
    if (container.hasAttribute("data-filter-group-values")) {
      setTimeout(() => {
        mainCollectionElement.style.minHeight =
          filters.getBoundingClientRect().height + activeFilters.getBoundingClientRect().height + "px";
      }, 300);
    }
  });
});
contractButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    e.preventDefault();
    let container = e.target.closest("[data-filter-group-values]");
    if (!container) container = e.target.closest(".filter-drawer__group");
    const list = container.querySelector("[data-filter-count]");
    list.style.removeProperty("max-height");
    e.target.style.display = "none";
    container.querySelector("[data-show-filters]").style.removeProperty("display");
    if (container.hasAttribute("data-filter-group-values")) {
      setTimeout(() => {
        mainCollectionElement.style.minHeight =
          filters.getBoundingClientRect().height + activeFilters.getBoundingClientRect().height + "px";
      }, 300);
    }
  });
});

trigger.addEventListener("click", toggleFilters);

if (mainCollectionElement.classList.contains("filters-expanded"))
  mainCollectionElement.style.minHeight = getFilterHeight() + "px";

window.setFilterContainerOffset = setFilterContainerOffset;
setFilterContainerOffset(1);

setTimeout(() => {
  const filterGroups = [...document.querySelectorAll(".filter-group")].filter((g) => !(g.style?.display === "none"));
  if (filterGroups.length) filterGroups[0].classList.add("first");
}, 300);

function setFilterContainerOffset(timeout = 500) {
  setTimeout(() => {
    if (activeFilters.querySelector("[data-value]"))
      filters.style.top = `${activeFilters.getBoundingClientRect().height}px`;
    else filters.style.top = 0;
  }, timeout);
}

function getFilterHeight() {
  return filters.getBoundingClientRect().height + activeFilters.getBoundingClientRect().height;
}

function expandFilters() {
  mainCollectionElement.classList.add("filters-expanded");
  activeFilters.classList.add("expanded");
  filterContainer.classList.add("expanded");
  triggerText.innerText = triggerText.dataset.closeText;
  mainCollectionElement.style.minHeight = getFilterHeight() + "px";
}

function collapseFilters() {
  mainCollectionElement.classList.remove("filters-expanded");
  activeFilters.classList.remove("expanded");
  filterContainer.classList.remove("expanded");
  triggerText.innerText = triggerText.dataset.openText;
  mainCollectionElement.style.minHeight = 0;
}

function toggleFilters() {
  if (mainCollectionElement.classList.contains("filters-expanded")) return collapseFilters();
  expandFilters();
}
